import React, { Component } from 'react';
import { connect } from 'react-redux';

import MobileViewDetailsWrapper from './styles/mobile-view-details-popover.style';
import Loader from '../../Loader/loader';
import { getSecondsInTextTime } from '../../../utils/getInititials';
import moment from 'moment';



class MobileViewDetails extends Component {
	constructor(props) {
		super(props);
		this.state={
			viewActive:false
		}
		this.openViewDetail=this.openViewDetail.bind(this);
		this.closeViewDetail=this.closeViewDetail.bind(this);
	}

	openViewDetail() {
        this.setState({ viewActive: false });	
	}

	closeViewDetail() {
		this.setState({ viewActive: false });	
		this.props.closeViewDetail(); 
	}
	
	render() {
		const { therapists, removeCall, onCallStatus } = this.props;
		const { activeCall } = therapists;
		
		if(!activeCall.callId){
			return (
				<MobileViewDetailsWrapper>
					<div className="m-view-details" className={this.state.viewActive  || this.props.openViewDetail ? 'm-view-details detail-slidein': 'm-view-details detail-slideout'}>
						<Loader />
					</div>
				</MobileViewDetailsWrapper>);

		}
		
		return (
			<MobileViewDetailsWrapper>
				<div className="m-view-details" className={this.state.viewActive  || this.props.openViewDetail ? 'm-view-details detail-slidein': 'm-view-details detail-slideout'}>
				<header className="m-videdetailsHeader">
					<span className="back-btn" onClick={this.props.closeViewDetail}><img src="/images/back-icon.png" width="7" /></span>
					<div className="header-field">
					<h1>{activeCall.patient}</h1>
					<h2>Waiting  {activeCall.waitingTime && getSecondsInTextTime(activeCall.waitingTime)}</h2>
					</div>
					<div className="action">
					<button className="visit-details kurebtn">visit details</button>
					</div>
				</header>
				<div className="m-viewdetails-content">
					<div className="content">
					<h3>{activeCall.patient}</h3>
					<h4>DOB: {activeCall.dob ? moment(activeCall.dob).format("MM/DD/YYYY") : ""}</h4>
					{activeCall.relInfo.name && [<h1>caregiver</h1>,
					<h3>{activeCall.relInfo.name}</h3>,
					<h2 className="p-0">+{activeCall.relInfo.phone}</h2>,
					<h4>{activeCall.relInfo.relation}</h4>]}
					{activeCall.scheduleInfo._id ? [<h1>visit type</h1>,
					<h2>{activeCall.scheduleInfo.Visit.Reason}</h2>,
					<h1>confirmation status</h1>,
					<h2>{activeCall.scheduleInfo.scheduleStatus}</h2>] :
					<h5>NO VISIT ON YOUR SCHEDULE FOR TODAY</h5>}
					</div>
					{/* <div className="actionWrapper">
					<div className="control disconnect">
					<img src="/images/microphone@2x.png" width="10" />
					</div>
					<div className="control connect">
					<img src="/images/video-off@2x.png" width="10" />
					</div>
					</div> */}
					<div className="classifications">
					<div className="item">
				  <span>Device</span>
				  <h1>{activeCall.patientDeviceInfo.device}</h1>
			  </div>
			  <div className="item">
			  <span>OS</span>
				  <h1>{activeCall.patientDeviceInfo.OS}</h1>
			  </div>
			  <div className="item">
			  <span>Browser</span>
				  <h1>{activeCall.patientDeviceInfo.browser}</h1>
			  </div>
					</div>
				</div>
				{!onCallStatus && <button className="removeParticipant-btn" onClick={removeCall}>remove</button>}
				</div>
			</MobileViewDetailsWrapper>
		  ) 
	}
}

export default connect(
	state => state
)(MobileViewDetails);

